import { Controller } from "@hotwired/stimulus"

// TikTokコメントの返信折りたたみを制御するStimulusコントローラー
export default class extends Controller {
  static targets = ["replies", "button", "icon"]

  // 返信の表示/非表示を切り替え
  toggleReplies(event) {
    const button = event.currentTarget
    const commentId = button.dataset.commentId
    const replies = document.querySelectorAll(`#replies_${commentId}`)
    const icon = button.querySelector('.iconify')

    // 返信行の表示/非表示を切り替え
    replies.forEach(reply => {
      reply.classList.toggle('hidden')
    })

    // アイコンの向きを変更
    if (icon.classList.contains('lucide--chevron-down')) {
      icon.classList.remove('lucide--chevron-down')
      icon.classList.add('lucide--chevron-up')
    } else {
      icon.classList.remove('lucide--chevron-up')
      icon.classList.add('lucide--chevron-down')
    }
  }
}
